/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_SuggestionInputs */

const en_us2_offline_kind_suggestion = /** @type {(inputs: Offline_Kind_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion dismissed`)
};

const pt_br2_offline_kind_suggestion = /** @type {(inputs: Offline_Kind_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestão dispensada`)
};

const es_419_offline_kind_suggestion = /** @type {(inputs: Offline_Kind_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerencia descartada`)
};

const pt_pt2_offline_kind_suggestion = /** @type {(inputs: Offline_Kind_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestão dispensada`)
};

const fr_fr2_offline_kind_suggestion = /** @type {(inputs: Offline_Kind_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion ignorée`)
};

const de_de2_offline_kind_suggestion = /** @type {(inputs: Offline_Kind_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschlag ausgeblendet`)
};

const it_it2_offline_kind_suggestion = /** @type {(inputs: Offline_Kind_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerimento ignorato`)
};

/**
* | output |
* | --- |
* | "Suggestion dismissed" |
*
* @param {Offline_Kind_SuggestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_suggestion = /** @type {((inputs?: Offline_Kind_SuggestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_SuggestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_suggestion(inputs)
	if (locale === "es-419") return es_419_offline_kind_suggestion(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_suggestion(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_suggestion(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_suggestion(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_suggestion(inputs)
	return en_us2_offline_kind_suggestion(inputs)
});
export { offline_kind_suggestion as "offline.kind_suggestion" }